exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".datatable-column{padding:.75rem 1rem;cursor:pointer;user-select:none}.datatable-sort-arrow{width:0;height:0;border:.375rem solid transparent}.datatable-sort-arrow-asc{border-bottom-color:currentColor;transform:translateY(-.1875rem)}.datatable-sort-arrow-desc{border-top-color:currentColor;transform:translateY(.1875rem)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-32af58a3!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Datatable/datatable-column.vue
// module id = 935
// module chunks = 0